
























































































































































































































































































import IGood from '@/store/models/IGood';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import { ExciseDrinkCategory } from '@/components/Enums/ExciseDrinkCategory';

@Component({
    components: {
        Snackbar
    }
})
export default class GoodSelector extends Vue {
    searchGood: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;

    headers: any = [
        { text: '', value: 'data-table-select', width: '48px', sortable: false },
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Good Number', value: 'code' },
        { text: 'Sku', value: 'sku' },
        { text: 'EAN Code', value: 'eanCode' },
        { text: 'Amount per box', value: 'amountPerBox' },
        { text: 'Weight (Kg)', value: 'weight' },
        { text: 'Alcohol %', value: 'alcoholPercentage' },
        { text: 'Liters per unit', value: 'litersPerUnit' },
        { text: 'Excise Category', value: 'exciseCategory' },
        { text: 'Customs Code', value: 'customsCode' },
        { text: 'Actions', value: 'actions', sortable: false, width: '96px' }
    ];

    editedIndex: number = -1;

    editedItem: IGood = {
        id: "",
        name: "",
        code: "",
        eanCode: "",
        specifications: "",
        amountPerBox: 1,
        sku: "",
        weight: 0,
        alcoholPercentage: 0,
        litersPerUnit: 0,
        exciseCategory: ExciseDrinkCategory.Other,
        customsCode: ""
    };

    defaultItem: IGood = {
        id: "",
        name: "",
        code: "",
        eanCode: "",
        specifications: "",
        amountPerBox: 1,
        sku: "",
        weight: 0,
        alcoholPercentage: 0,
        litersPerUnit: 0,
        exciseCategory: ExciseDrinkCategory.Other,
        customsCode: ""
    };

    @Prop({ type: Array, required: true })
    GoodList!: IGood[];

    @Prop({ type: Array, required: true })
    Permissions!: IRolePermission[];

    @Prop({ type: Boolean, default: false })
    enableExciseModule!: boolean;

    @Prop()
    value!: IGood | null;

    selectedGood: IGood[] = [];
    exciseCategories = Object.values(ExciseDrinkCategory);

    get formTitle() {
        return this.editedIndex === -1 ? 'New Good' : 'Edit Good';
    }

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (!val) {
            this.close();
        }
    }

    @Watch('value', { immediate: true })
    updateSelection(newValue: IGood | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedGood = [];
        } else {
            this.selectedGood = [newValue];
        }
    }

    @Watch('selectedGood')
    onSelectedGoodChanged(newValue: IGood[]) {
        if (newValue && newValue.length > 0) {
            this.$emit('input', newValue[0]);
        } else {
            this.$emit('input', null);
        }
    }

    resetGood() {
        this.$emit('resetGood');
    }

    handleRowClick(item: IGood, select: (value: boolean) => void) {
        const isSelected = this.selectedGood.some(g => g.id === item.id);
        select(!isSelected);
    }

    editGood(item: IGood) {
        this.editedIndex = this.GoodList.findIndex(g => g.id === item.id);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    checkIfExists(good: IGood) {
        return this.GoodList.findIndex(g =>
            g.name === good.name &&
            g.id !== good.id
        );
    }

    saveGood() {
        const good = this.editedItem;

        if (this.checkIfExists(good) !== -1) {
            this.showMessageWarning('This product already exists.');
            return;
        }

        const form = this.$refs.form as Vue & { validate: () => boolean };
        if (!form.validate()) {
            this.showMessageWarning('All required fields must be filled out');
            return;
        }

        if (this.editedIndex > -1) {
            this.$emit('editGood', this.editedItem);
            Object.assign(this.GoodList[this.editedIndex], this.editedItem);
        } else {
            this.$emit('saveGood', this.editedItem);
        }

        this.close();
    }

    deleteGood(good: IGood) {
        this.$emit('deleteGood', good);
    }

    close(): void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
